import { Injectable } from '@angular/core';

import { AskTicketsDataSourceService } from '../../ask-tickets-view/ask-tickets-data-source.service';

@Injectable()
export class ChatTicketsDataSourceService extends AskTicketsDataSourceService {
  public onRecordClick = (ticket: { id: number }) => {
    this.ticketDialogService.openTicketDialog(ticket.id, { routerStrategy: false });
  };
}
